import { Checkbox } from '@mui/material';
import styled from 'styled-components';
import { muiTheme } from './muiTheme';

export const StyledCheckboxGeneral = styled(Checkbox)`
  &:after {
    content: "";
    display: block;
    position: absolute;
    pointer-events: none;
    z-index: 1;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    background: ${muiTheme.palette.common.white};
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }

  svg {
    z-index: 2;
    pointer-events: none;
  }
`;